import { render, staticRenderFns } from "./articledetail.vue?vue&type=template&id=2053b43e&scoped=true"
import script from "./articledetail.vue?vue&type=script&lang=js"
export * from "./articledetail.vue?vue&type=script&lang=js"
import style0 from "./articledetail.vue?vue&type=style&index=0&id=2053b43e&prod&scoped=true&lang=css"
import style1 from "./articledetail.vue?vue&type=style&index=1&id=2053b43e&prod&lang=css"
import style2 from "./articledetail.vue?vue&type=style&index=2&id=2053b43e&prod&scoped=true&lang=css"
import style3 from "./articledetail.vue?vue&type=style&index=3&id=2053b43e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2053b43e",
  null
  
)

export default component.exports